var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"w-100 flex-grow-1"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"articles_data":_vm.articles_data,"props_search":_vm.props_search}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }